import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
    const { login, error } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("admin@playershealth.com");
    const [password, setPassword] = useState("PlayersHealth2026!");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const ok = await login(email, password);
        setLoading(false);
        if (ok) nav("/app");
    };

    return (
        <div className="min-h-screen flex bg-ph-canvas">
            {/* Hero panel */}
            <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                <img
                    src="/login-hero.png"
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 w-full h-full object-cover select-none"
                    draggable={false}
                />
                {/* Subtle bottom gradient for legibility of caption */}
                <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/55 via-black/20 to-transparent" />
                <div className="relative z-10 flex flex-col justify-end p-10 w-full">
                    <div>
                        <div className="text-white/80 text-xs uppercase tracking-[0.25em] font-semibold mb-3 drop-shadow-[0_1px_8px_rgba(0,0,0,0.45)]">
                            PH Price's Law
                        </div>
                        <div className="text-white text-2xl xl:text-3xl font-semibold leading-tight tracking-tight max-w-lg drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]">
                            50% of the results and contributions are produced by the square root of the total number of people involved.
                        </div>
                    </div>
                </div>
            </div>

            {/* Form side */}
            <div className="flex-1 flex items-center justify-center p-6">
                <div className="w-full max-w-md">
                    <div className="flex items-center justify-center lg:justify-start mb-8">
                        <img
                            src="/players-health-logo.png"
                            alt="Players Health"
                            className="h-9 w-auto"
                            draggable={false}
                        />
                    </div>

                    <div className="ph-card p-7">
                        <h1 className="text-xl font-semibold text-ph-text">Sign in to your workspace</h1>
                        <p className="text-sm text-ph-muted mt-1">Welcome back. Continue to your BD pipeline.</p>

                        <form onSubmit={submit} className="space-y-4 mt-6" data-testid="login-form">
                            <div>
                                <label className="text-xs font-medium text-ph-text mb-1.5 block">Email</label>
                                <Input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="h-10"
                                    data-testid="login-email-input"
                                />
                            </div>
                            <div>
                                <label className="text-xs font-medium text-ph-text mb-1.5 block">Password</label>
                                <Input
                                    type="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="h-10"
                                    data-testid="login-password-input"
                                />
                            </div>
                            {error && (
                                <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="login-error">
                                    {error}
                                </div>
                            )}
                            <Button
                                type="submit"
                                disabled={loading}
                                className="w-full h-10 bg-ph-primary text-white font-medium hover:bg-ph-primaryHover transition-colors"
                                data-testid="login-submit-btn"
                            >
                                {loading ? "Signing in…" : "Sign in"}
                            </Button>
                        </form>
                        <div className="mt-4 text-right">
                            <Link
                                to="/forgot-password"
                                className="text-xs text-ph-muted hover:text-ph-primary"
                                data-testid="forgot-password-link"
                            >
                                Forgot your password?
                            </Link>
                        </div>
                    </div>

                    <div className="mt-6 text-xs text-center text-ph-mutedSoft">
                        Need access? Ask your admin to send you an invite.
                    </div>
                </div>
            </div>
        </div>
    );
}
